export default __webpack_public_path__ + "static/media/mail_open.47f729af.svg";